import {
  AssetReportFooterLabelsContainer,
  AssetReportFooterStyle,
  AssetReportFooterTitle,
  AssetReportFooterEmail,
  AssetReportFooterLogoDiv,
} from './assetReportFooter.styles';
import { ReactComponent as UDALogo } from '../../../assets/images/symbolUda.svg';
import { ReportDataResponse } from '../../../types/reportData.interface';

export function AssetReportFooter(props: ReportDataResponse) {
  return (
    <AssetReportFooterStyle>
      <AssetReportFooterLabelsContainer>
        {props.company && (
          <AssetReportFooterTitle>{props.company}</AssetReportFooterTitle>
        )}
        {props.email && (
          <AssetReportFooterEmail>{props.email}</AssetReportFooterEmail>
        )}
      </AssetReportFooterLabelsContainer>
      <AssetReportFooterLogoDiv>
        <UDALogo /> powered by Accumin
      </AssetReportFooterLogoDiv>
    </AssetReportFooterStyle>
  );
}
